module.exports = __webpack_public_path__ + "img/644.319d6eef.png";